let sm2 = require('./sm2/index')
let sm3 = require('./sm3/index')
let sm4 = require('./sm4/index')
import { AESDecryptStr } from './decrypt/index'
export let cq = {
  install(Vue) {
    Vue.prototype.$sm2 = sm2
    Vue.prototype.$sm3 = sm3
    Vue.prototype.$sm4 = sm4
    Vue.prototype.$AESDecryptStr = AESDecryptStr
  }
}